<template>
  <div>
    <v-row class="pa-4">
      Settings
      <v-spacer></v-spacer>
      <t-item-diff v-if="$store.state.settings.debugMode" :item1="lastSave" :item2="formData">
        <v-layout 
        slot="item1Header"
        align-center class="subheading font-weight-bold pl-2 crx-toolbar">
          Last save
        </v-layout>
        <v-layout 
        slot="item2Header"
        align-center class="subheading font-weight-bold pl-2 crx-toolbar">
          LIVE
        </v-layout>
      </t-item-diff>
    </v-row>
    <div>
      <div class="text-center pa-4">
        <div>
          The next invoice generated will be: 
        </div>
        <span class="headline font-weight-medium">{{ formData.next_id }}{{ formData.append_string }}</span>
      </div>

      <v-row class="align-start">
        <v-col md="3">
          <div class="label">Next Invoice Number:</div>
        </v-col>
        <v-col md="9">
          <c-input :value.sync="formData.next_id" class="crx-box-input"></c-input>
          <div class="label">
            The next numerical id to assign to an invoice. e.g. 1. This is incremented by one each time you create an invoice
          </div>
        </v-col>
      </v-row>

      <v-row class="align-start">
        <v-col md="3">
          <div class="label">Append Text:</div>
        </v-col>
        <v-col md="9">
          <c-input :value.sync="formData.append_string" class="crx-box-input"></c-input>
          <div class="label">
            Text appended after an invoice number 55/p1/2020 - in this case '/p1/2020' is the appended text
          </div>
        </v-col>
      </v-row>

      <v-row class="justify-end mt-3 pa-4">
        <v-btn
        :disabled="!isDirty"
        :loading="saving"
        color="color1" 
        class="white--text"
        @click="save">
          Save
        </v-btn>
      </v-row>

    </div>
  </div>
</template>

<script>
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'

export default {
  data () {
    return {
      formData: {
        append_string: '',
        next_id: 1
      },
      lastSave: {
        append_string: '',
        next_id: 1
      },
      isLoading: false,
      saving: false
    }
  },
  computed: {
    isDirty () {
      return !_.isEqual(this.lastSave, this.formData)
    },
  },
  methods: {
    save () {
      this.saveAxios()
      .then(() => {
        this.reload()
      })
      .catch(error => this.$root.$errorSnackbar(error))
    },
    reload: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        var data = [STATIC_SETTINGS.INVOICE_ID_APPEND, STATIC_SETTINGS.INVOICE_ID_NEXT_ID]
        this.$axios.post(`/settings/get-multiple`, data)
          .then(response => {
            var settings = response.data
            this.formData.append_string = settings[STATIC_SETTINGS.INVOICE_ID_APPEND]
            this.formData.next_id = settings[STATIC_SETTINGS.INVOICE_ID_NEXT_ID]

            this.lastSave.append_string = settings[STATIC_SETTINGS.INVOICE_ID_APPEND]
            this.lastSave.next_id = settings[STATIC_SETTINGS.INVOICE_ID_NEXT_ID]
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
    saveAxios () {
      return new Promise((resolve, reject) => {
        let data = {}
        data[STATIC_SETTINGS.INVOICE_ID_APPEND] = this.formData.append_string
        data[STATIC_SETTINGS.INVOICE_ID_NEXT_ID] = parseInt(this.formData.next_id)
  
        this.saving = true
        this.$axios.post('settings/update-multiple', data)
          .then(response => {
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    }
  },
  created () {
    this.reload()
  }
}
</script>